import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { FileTypeDTO } from "../models/File/FileTypeDTO";
import { Parameter } from "../models/Parameter";
import { APIService } from "./APIService";

export class FileTypeService {

    async GetAll(): Promise<MessagingHelper<FileTypeDTO[]>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/FileType/GetAll`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<FileTypeDTO[]>(
                false,
                "Erro ao ligar ao servidor para obter tipos de ficheiros",
                [],
            );
        }
    }

    async GetAllPaginated(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,) : Promise<PaginatedList<FileTypeDTO>>
        {
            try {
                var response = await APIService.Axios().post(
                    `${APIService.GetURL()}/FileType/GetAllPaginated`,
                    {
                        searchParameters,
                        sortingParameters,
                        currentPage,
                        pageSize,
                    },
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + APIService.GetToken(),
                        },
                    },
                );
                return response.data;
            } catch (error) {
                return new PaginatedList<FileTypeDTO>(
                    false,
                    "Erro ao obter a informação dos tipo de ficheiros",
                    "",
                    [],
                    0,
                );
            }
        }

    async GetById(id: number) : Promise<MessagingHelper<FileTypeDTO | null>>
    {
        try{
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/FileType/${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        }catch(error) {
            return new MessagingHelper<null>(false, "Erro ao obter o tipo de ficheiro", null);
        }
    }
    async Edit(data: FileTypeDTO) : Promise<MessagingHelper<null>>
    {
        try{
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/FileType/Edit`,
                {
                   ...data
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        }catch(error) {
            return new MessagingHelper(false, "Erro ao editar o tipo de ficheiro", null);
        }
    }
}